module.exports = __webpack_public_path__ + "img/radio_icon.af04cb06.svg";